import React, { useEffect, useRef } from 'react';

// Nút "Sign in with Google" dùng Google Identity Services (GIS).
// Tải script GIS một lần, khởi tạo với Client ID rồi render nút chính chủ của Google.
const GIS_SRC = 'https://accounts.google.com/gsi/client';
let gisPromise: Promise<void> | null = null;

const loadGis = (): Promise<void> => {
  if ((window as any).google?.accounts?.id) return Promise.resolve();
  if (gisPromise) return gisPromise;

  gisPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = GIS_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Không tải được Google Identity Services'));
    document.head.appendChild(script);
  });

  return gisPromise;
};

interface GoogleLoginButtonProps {
  clientId: string;
  onCredential: (idToken: string) => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ clientId, onCredential }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;

    loadGis()
      .then(() => {
        if (cancelled || !containerRef.current) return;
        const google = (window as any).google;

        google.accounts.id.initialize({
          client_id: clientId,
          callback: (resp: any) => {
            if (resp?.credential) onCredential(resp.credential);
          },
        });

        google.accounts.id.renderButton(containerRef.current, {
          theme: 'outline',
          size: 'large',
          type: 'standard',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'center',
          width: 300,
        });
      })
      .catch(() => {
        /* GIS load lỗi — nút Google sẽ không hiện, người dùng vẫn dùng cách khác */
      });

    return () => {
      cancelled = true;
    };
  }, [clientId, onCredential]);

  return <div ref={containerRef} style={{ display: 'flex', justifyContent: 'center' }} />;
};

export default GoogleLoginButton;
